import React, {Component} from 'react';
import Menu from "../Menu";
import PageHeader from "../PageHeader";
import GlobalVariable from "../../GlobalVariable";
import api from "../../api";
import './ScheduleStaffs.scss';


export class ScheduleStaffs extends Component <any, any> {
    private scheduleScrollRef = React.createRef<HTMLDivElement>();
    private requestSequence = 0;

    constructor(props: any) {
        super(props);window.scrollTo(0, 0);
        this.state = {
            showBlock: false,
            showBlockMonth: false,
            activeAddress: 'Загружаем адрес',
            activeMonth: 'Загружаем месяц',
            activeAddressId: null,
            activeMonthApi: null,
            dayMonth: [],

            staffSchedule: [],
            monthArrayName: [],
            timePeriod: [{id: 1, from: '10:00', to: '20:00', onlineRecord: true}],
            AddressArray: [],
            activeDay: [],
            isOpenChooseTime: false,
            SettingScheduleYourself: false,
            SettingScheduleAll: false,
            scheduleNotice: '',
            isLoad: false,
            isSaving: false,
        };
        this.changeActiveMonth = this.changeActiveMonth.bind(this);
    }

    getInfo(activeMonthApi: string | null = null, activeAddressId: number | string | null = null, scrollLeft = 0) {
        const requestId = ++this.requestSequence;
        this.setState({isLoad: false, scheduleNotice: ''});
        let urlAPI = GlobalVariable.host() + '/widget/staff/date-schedule/' + activeMonthApi + '/' + activeAddressId;
        const data = {};
        api({
            url: urlAPI,
            headers: {'Content-Type': 'application/json'},
            method: "GET",
            data: data,
            withCredentials: true,
            // receive two    parameter endpoint url ,form data
        })
            .then(result => { // then print response status
                if (requestId !== this.requestSequence) return;
                const addressArray = result.data.CompanyUserEnable || [];
                const activeCompany = addressArray.find((item) => Number(item.id) === Number(activeAddressId)) || addressArray[0] || {};
                const activeMonth = result.data.activeMonth || {};
                const dayMonth = Array.isArray(result.data.dayMonth) ? result.data.dayMonth : [];
                this.setState({
                    staffSchedule: result.data.staffSchedule || [],
                    dayMonth: dayMonth,
                    AddressArray: addressArray,
                    activeAddress: activeCompany.address || 'Салон не выбран',
                    activeAddressId: activeCompany.id || activeAddressId,
                    monthArrayName: result.data.monthArrayName || [],
                    activeMonthApi: activeMonth.apiDate || null,
                    activeMonth: activeMonth.alias || 'Месяц не выбран',
                    SettingScheduleAll: result.data.SettingScheduleAll,
                    SettingScheduleYourself: result.data.SettingScheduleYourself,

                    isLoad: true,
                    auth: true,
                    scheduleNotice: '',
                }, () => {
                    if (this.scheduleScrollRef.current) this.scheduleScrollRef.current.scrollLeft = scrollLeft;
                });
            }).catch(error => {
            if (requestId !== this.requestSequence) return;
            if (error?.response?.status === 401 || Number(error.code) === 401) {
                window.location.href = '/start';
            }

            this.setState({
                auth: false,
                isLoad: true,
                staffSchedule: [],
                dayMonth: [],
                scheduleNotice: 'Не удалось загрузить график. Попробуйте обновить страницу.',
            })
            // window.location.href = '/' ;
        })
    }

    componentDidMount() {
        this.getInfo()
    }

    changeActiveAddress(address, id) {
        this.setState({
            'activeAddress': address,
            'activeAddressId': id,
            'showBlock': false,
            activeDay: [],
        })
        this.getInfo(this.state.activeMonthApi, id)
    }

    changeActiveMonth(month) {
        this.setState({
            'activeMonth': month.alias,
            'activeMonthApi': month.apiDate,
            'showBlockMonth': false,
        })
        this.setState({activeDay: []});
        this.getInfo(month.apiDate, this.state.activeAddressId)
    }

    showBlock() {
        if (this.state.showBlock) {
            return (
                <div className='schedule-dropdown'>
                    {
                        this.state.AddressArray.map((itemMonth) => (
                            <button
                                key={itemMonth.id}
                                type='button'
                                className={this.state.activeAddressId === itemMonth.id ? 'is-active' : ''}
                                onClick={() => this.changeActiveAddress(itemMonth.address, itemMonth.id)}
                            >
                                {itemMonth.address}
                            </button>
                        ))
                    }

                </div>
            )
        }
    }

    showBlockMonth() {
        if (this.state.showBlockMonth) {

            return (
                <div className='schedule-dropdown'>
                    {

                        this.state.monthArrayName.map((itemMonth) => (
                            <button
                                key={itemMonth.apiDate}
                                type='button'
                                className={this.state.activeMonthApi === itemMonth.apiDate ? 'is-active' : ''}
                                onClick={() => this.changeActiveMonth(itemMonth)}
                            >
                                {itemMonth.alias}
                            </button>
                        ))
                    }

                </div>
            )
        }
    }

    searchDayActive(newArray, array, arr = true) {
        let status = false;
        let index = null;
        newArray.forEach(function (item, i, newArray) {

            if (JSON.stringify(item) === JSON.stringify(array)) {
                status = true;
                index = i;
                return {status: status, index: index}
            }
        });

        return {status: status, index: index}
    }

    canEditSchedule() {
        return Boolean(this.state.SettingScheduleAll || this.state.SettingScheduleYourself);
    }

    activeDay(array) {
        if (!this.canEditSchedule()) {
            this.setState({scheduleNotice: 'Нет прав на изменение графика'});
            return;
        }

        const newArray = [...this.state.activeDay];
        const status = this.searchDayActive(newArray, array, true);

        if (!status?.status) {
            newArray.push(array);
            this.setState({
                activeDay: newArray,
                scheduleNotice: '',
            });
            return;
        }

        const index = Number((status as any).index);
        if (!Number.isNaN(index)) {
            newArray.splice(index, 1);
            this.setState({
                activeDay: newArray,
                scheduleNotice: '',
            });
        }
    }

    changeTimePeriodOnlineRecord(id, onlineRecord) {
        console.log([id, onlineRecord])

        let newArr = this.state.timePeriod;
        const nextStatus = !this.state.timePeriod[id].onlineRecord;
        let newArr2 = {
            id: id,
            from: this.state.timePeriod[id].from,
            to: this.state.timePeriod[id].to,
            onlineRecord: nextStatus
        }
        newArr.splice(id, 1, newArr2);
        console.log(newArr)
        this.setState({
            timePeriod: newArr
        })
    }

    changeTimePeriodOnlineTo(id, to) {


        let newArr = this.state.timePeriod;

        let newArr2 = {
            id: id,
            from: this.state.timePeriod[id].from,
            to: to.target.value,
            onlineRecord: this.state.timePeriod[id].onlineRecord
        }
        newArr.splice(id, 1, newArr2);
        console.log(newArr)
        this.setState({
            timePeriod: newArr
        })
    }

    changeTimePeriodOnlineFrom(id, from) {


        let newArr = this.state.timePeriod;
        let newArr2 = {
            id: id,
            from: from.target.value,
            to: this.state.timePeriod[id].to,
            onlineRecord: this.state.timePeriod[id].onlineRecord
        }
        newArr.splice(id, 1, newArr2);
        console.log(newArr)
        this.setState({
            timePeriod: newArr
        })
    }

    addSlot() {
        let newArr = this.state.timePeriod;
        newArr.push({id: 1, from: '10:00', to: '20:00', onlineRecord: true})
        this.setState({
            timePeriod: newArr
        })
    }

    deleteSlot(id) {
        let newArr = this.state.timePeriod;
        newArr.splice(id, 1);

        this.setState({
            timePeriod: newArr
        })
    }

    getActiveAddressArray() {
        const selected = (this.state.AddressArray || []).find((item) => Number(item.id) === Number(this.state.activeAddressId));
        return selected ? [selected] : this.state.AddressArray;
    }

    sendScheduleStaffs(clean = false) {
        if (this.state.isSaving || this.state.activeDay.length === 0) return;
        this.setState({isSaving: true, scheduleNotice: ''});
        let urlAPI = GlobalVariable.host() + '/widget/staff/date-schedule-add';
        const data = {
            month: this.state.activeMonthApi,
            arrayStaffAndDate: this.state.activeDay,
            timePeriod: this.state.timePeriod,
            addressArray:this.getActiveAddressArray(),
            clean:clean,
        };
        api({
            url: urlAPI,
            headers: {'Content-Type': 'application/json'},
            method: "POST",
            data: data,
            withCredentials: true,
            // receive two    parameter endpoint url ,form data
        })
            .then(result => { // then print response status
                const scrollLeft = this.scheduleScrollRef.current ? this.scheduleScrollRef.current.scrollLeft : 0;
                this.getInfo(this.state.activeMonthApi, this.state.activeAddressId, scrollLeft)
                this.setState({
                    activeDay: [],
                    isOpenChooseTime: false,
                    isSaving: false,
                })
            }).catch(error => {
            if (error?.response?.status === 401 || Number(error.code) === 401) {
                window.location.href = '/start';
            }

            this.setState({
                isSaving: false,
                scheduleNotice: 'Не удалось сохранить смены. Попробуйте ещё раз.',
            })
            // window.location.href = '/' ;
        })
    }

    toggleChooseTime() {
        return (
            <div className='schedule-time-overlay' onClick={() => this.setState({isOpenChooseTime: false})}>
                <div className='choose-time' onClick={(event) => event.stopPropagation()}>
                    <div className='schedule-sheet-handle'></div>
                    <div className='schedule-sheet-head'>
                        <div>
                            <h2>Изменить смены</h2>
                            <p>{this.state.activeDay.length} выбранных дней</p>
                        </div>
                        <button type='button' onClick={() => this.setState({isOpenChooseTime: false})}>×</button>
                    </div>

                    <div className='schedule-time-head'>
                        <span>Удалить</span>
                        <span>Смена с</span>
                        <span>Смена до</span>
                        <span>Онлайн</span>
                    </div>

                    {this.state.timePeriod.map((item, k) => (
                        <div className='time-row' key={k}>
                            <button type='button' onClick={() => this.deleteSlot(k)} className='schedule-delete-slot'>
                                <img src='/img/trash3.svg' alt=''/>
                            </button>
                            <input onChange={(e) => this.changeTimePeriodOnlineFrom(k, e)}
                                   value={item.from} type='time' placeholder='xx:xx'/>
                            <input onChange={(e) => this.changeTimePeriodOnlineTo(k, e)}
                                   value={item.to} type='time' placeholder='xx:xx'/>
                            <label className='schedule-online-toggle'>
                                <input onChange={() => this.changeTimePeriodOnlineRecord(k, item.onlineRecord)}
                                       type='checkbox' checked={item.onlineRecord} placeholder='xx:xx'/>
                                <span></span>
                            </label>
                        </div>
                    ))}

                    <button type='button' onClick={() => this.addSlot()} className='schedule-add-slot'>
                        <span>+</span>
                        Добавить промежуток
                    </button>

                    {this.state.scheduleNotice ? <div className='schedule-sheet-notice' role='alert'>{this.state.scheduleNotice}</div> : null}

                    <div className='schedule-sheet-actions'>
                        <button type='button' className='schedule-secondary-action' disabled={this.state.isSaving}
                                onClick={() => this.setState({isOpenChooseTime: false})}>Отмена</button>
                        <button type='button' disabled={this.state.isSaving} onClick={() => this.sendScheduleStaffs()} className='schedule-primary-action'>{this.state.isSaving ? 'Сохраняем…' : 'Сохранить'}</button>
                        <button type='button' disabled={this.state.isSaving} className='schedule-danger-action' onClick={() => this.sendScheduleStaffs(true)}>Пометить нерабочими</button>
                    </div>
                </div>
            </div>
        )

    }

    getMonthDays() {
        return (this.state.dayMonth || []).map((label, index) => ({
            dayNumber: index + 1,
            weekday: String(label).split(' ').slice(1).join(' '),
        }));
    }

    monthWorkDaysCount(days) {
        return (this.state.staffSchedule || []).reduce((count, staff) => {
            return count + days.filter(({dayNumber}) => {
                const slots = (staff.day || [])[dayNumber - 1];
                return Array.isArray(slots) && slots.length > 0;
            }).length;
        }, 0);
    }

    monthGenitive() {
        const month = Number(String(this.state.activeMonthApi || '').split('-')[1]);
        return ['','января','февраля','марта','апреля','мая','июня','июля','августа','сентября','октября','ноября','декабря'][month] || '';
    }

    startFirstShift(dayNumber) {
        const firstStaff = (this.state.staffSchedule || [])[0];
        if (!firstStaff || !this.canEditSchedule()) return;
        this.setState({activeDay: [[firstStaff.staffId, dayNumber]], isOpenChooseTime: true});
    }

    renderDaySlots(day) {
        if (!Array.isArray(day) || day.length === 0) {
            return <span className='schedule-empty-day'>+</span>;
        }

        return day.map((item, index) => {
            const from = String(item.from || '').replace(/:00$/, '');
            const to = String(item.to || '').replace(/:00$/, '');
            return <span className={`schedule-slot-chip ${item.onlineRecord === false ? 'is-offline' : ''}`} key={`${item.from}-${item.to}-${index}`}>
                {from}–{to}
            </span>;
        });
    }

    render() {
        const selectedCount = this.state.activeDay.length;
        const staffCount = (this.state.staffSchedule || []).length;
        const monthDays = this.getMonthDays();
        const workDaysCount = this.monthWorkDaysCount(monthDays);
        const hasOfflineShift = (this.state.staffSchedule || []).some((staff) => monthDays.some(({dayNumber}) =>
            ((staff.day || [])[dayNumber - 1] || []).some((slot) => slot.onlineRecord === false)
        ));
        const canEdit = this.canEditSchedule();
        const firstDay = monthDays[0] ? monthDays[0].dayNumber : 0;

        return (
            <div className='main schedule-redesign'>
                <div className='content mx-w-content position-relative schedule-content'>
                    <PageHeader pageTitle='График работы' backBtnUrl='/'/>
                    <div className='pt-header'></div>
                    {this.props.onShowPersonal && <button type='button' className='schedule-personal-return' onClick={this.props.onShowPersonal}>← Мои смены по салонам</button>}

                    <section className='schedule-context'>
                        <div className='schedule-context-main'>
                            <h1>График мастеров</h1>
                            <div className='schedule-select-card schedule-salon-select'>
                                <button type='button' className='schedule-select-trigger' aria-label={`Салон: ${this.state.activeAddress}`}
                                    aria-expanded={this.state.showBlock}
                                    onClick={() => this.setState({showBlock: !this.state.showBlock, showBlockMonth: false})}>
                                    <span>{this.state.activeAddress}</span>
                                    <svg className='schedule-select-chevron' viewBox='0 0 12 12' aria-hidden='true'>
                                        <path d='m2.5 4.5 3.5 3 3.5-3' fill='none' stroke='currentColor' strokeWidth='1.7' strokeLinecap='round' strokeLinejoin='round'/>
                                    </svg>
                                </button>
                                {this.showBlock()}
                            </div>
                        </div>
                        <div className='schedule-select-card schedule-month-select'>
                            <button type='button' className='schedule-select-trigger' aria-label={`Месяц: ${this.state.activeMonth}`}
                                aria-expanded={this.state.showBlockMonth}
                                onClick={() => this.setState({showBlockMonth: !this.state.showBlockMonth, showBlock: false})}>
                                <span>{this.state.activeMonth}</span>
                                <svg className='schedule-select-chevron' viewBox='0 0 12 12' aria-hidden='true'>
                                    <path d='m2.5 4.5 3.5 3 3.5-3' fill='none' stroke='currentColor' strokeWidth='1.7' strokeLinecap='round' strokeLinejoin='round'/>
                                </svg>
                            </button>
                            {this.showBlockMonth()}
                        </div>
                    </section>

                    <section className='schedule-summary' aria-label='Сводка за месяц'>
                        <div><strong>{staffCount}</strong><span>Мастера</span></div>
                        <div><strong>{workDaysCount}</strong><span>Смен за месяц</span></div>
                        <div><strong>{selectedCount}</strong><span>Выбрано</span></div>
                    </section>

                    {this.state.scheduleNotice && !this.state.isOpenChooseTime ? (
                        <div className='schedule-notice' role='alert'>{this.state.scheduleNotice}</div>
                    ) : null}

                    {selectedCount > 0 ? (
                        <div className='schedule-selection-bar'>
                            <span>Выбрано: {selectedCount}</span>
                            <button type='button' onClick={() => this.setState({isOpenChooseTime: true})}>Изменить</button>
                            <button type='button' className='secondary' onClick={() => this.setState({activeDay: []})}>Снять</button>
                        </div>
                    ) : null}

                    <div className='schedule-board-heading'>График по дням</div>
                    {!this.state.isLoad ? (
                        <div className='schedule-empty-state'>Загружаем график…</div>
                    ) : staffCount > 0 && monthDays.length > 0 ? (
                        <>
                            <div className='schedule-board outer' ref={this.scheduleScrollRef}>
                                <div className='schedule-scroll inner'>
                                    <table className='schedule-table'>
                                        <thead><tr>
                                            <th scope='col'>Мастер</th>
                                            {monthDays.map(({dayNumber, weekday}) => (
                                                <th scope='col' key={dayNumber} className='schedule-date-head'>
                                                    <span>{weekday}</span><strong>{dayNumber}</strong>
                                                </th>
                                            ))}
                                        </tr></thead>
                                        <tbody>{this.state.staffSchedule.map((staff) => (
                                            <tr key={staff.staffId}>
                                                <th className='schedule-staff-cell' scope='row'><strong>{staff.staffName}</strong></th>
                                                {monthDays.map(({dayNumber}) => {
                                                    const slots = (staff.day || [])[dayNumber - 1];
                                                    const position = [staff.staffId, dayNumber];
                                                    const selected = this.searchDayActive(this.state.activeDay, position).status;
                                                    const hasShift = Array.isArray(slots) && slots.length > 0;
                                                    const slotText = hasShift ? slots.map((slot) => `${slot.from}–${slot.to}`).join(', ') : 'смены нет';
                                                    return <td key={`${staff.staffId}-${dayNumber}`} className='schedule-day-cell'>
                                                        <button type='button' disabled={!canEdit} aria-pressed={selected}
                                                            aria-label={`${staff.staffName}, ${dayNumber} ${this.monthGenitive()}: ${slotText}`}
                                                            className={`${selected ? 'is-selected' : ''} ${hasShift ? 'has-shift' : 'is-empty'}`}
                                                            onClick={() => this.activeDay(position)}>
                                                            {this.renderDaySlots(slots)}
                                                        </button>
                                                    </td>;
                                                })}
                                            </tr>
                                        ))}</tbody>
                                    </table>
                                </div>
                            </div>
                            <p className='schedule-swipe-hint'>← Листайте дни месяца влево и вправо →</p>
                            {workDaysCount > 0 ? (
                                <div className='schedule-legend'><span><i></i>Рабочая смена</span>{hasOfflineShift ? <span><i className='offline'></i>Без онлайн-записи</span> : null}</div>
                            ) : null}
                            {workDaysCount === 0 ? (
                                <div className='schedule-empty-callout'>
                                    <strong>На этот месяц смен пока нет</strong>
                                    <p>{canEdit ? 'Выберите «+» в таблице или добавьте первую смену.' : 'Смены появятся здесь, когда график будет составлен.'}</p>
                                    {canEdit && firstDay ? <button type='button' onClick={() => this.startFirstShift(firstDay)}>+ Добавить смену</button> : null}
                                </div>
                            ) : <p className='schedule-help'>{canEdit ? 'Нажмите на ячейки, чтобы выбрать несколько смен и изменить их вместе.' : 'График доступен для просмотра.'}</p>}
                        </>
                    ) : (
                        <div className='schedule-empty-state'>Для этого салона пока нет доступного расписания.</div>
                    )}

                    {this.state.isOpenChooseTime && this.toggleChooseTime()}
                </div>
                <Menu></Menu>
            </div>
        );
    }
}

export default ScheduleStaffs;
